import { RegistrationFormScreen } from '@/modules/onboarding/registration';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';
import type { RegistrationType } from '@/modules/onboarding/registration/store/registrationStore';

export default function RegistrationForm() {
    const { type } = useLocalSearchParams<{ type?: string }>();
    const registrationType: RegistrationType | undefined = type === 'passport' ? 'passport' : type === 'emirates-id' ? 'emirates-id' : undefined;
    
    return <RegistrationFormScreen {...(registrationType ? { registrationType } : {})} />;
}